import React from 'react';
import { RouteComponentProps } from 'react-router';
import {
  ProfessorStore,
  PROFESSOR_STORE,
  ProfessorModel,
  MONOGRAFIA_STORE,
  AgendamentoValidator,
  DataHoraValidator,
  MonografiaModel
} from '../../Store';
import { inject, observer } from 'mobx-react';
import ProfessorCard from './Components/ProfessorCard';
import SuplentesCard from './Components/SuplentesCard';
import AgendamentoCard from './Components/AgendamentoCard';
import DetalhesMonografia from './Components/DetalhesMonografia';
import { EditarAgendamentoModal } from './Components/EditarAgendamentoModal';
import styled from 'styled-components';
import { Button, Toast, ToastType, TutorialButtonAndBackButton, withStateCard } from '../../Components';
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';
import { apiState } from '../../Api';
import { format } from 'date-fns';
import Tutorial_Professor from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Professor.pdf";
import PageSubTitle from "../../Components/PageSubTitle";

interface IProps extends RouteComponentProps<{ id: string }> {
  [PROFESSOR_STORE]: ProfessorStore;
}

interface IState {
  isConvidadosIguais: boolean;
  isSuplentesIguais: boolean;
  modalIsOpen: boolean;
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const ContainerWithState = withStateCard(Container);

const StyledButton = styled(Button)`
  max-width: fit-content;
  justify-self: flex-end;
`;

const StyledText = styled.span`
  padding: 5px;
`;

@inject(PROFESSOR_STORE, MONOGRAFIA_STORE)
@observer
export default class AgendamentoBancaPage extends React.Component<IProps, IState> {
  cardRefs: { [key: string]: React.RefObject<any> };

  constructor(props: IProps) {
    super(props);

    this.cardRefs = {};

    this.state = {
      isConvidadosIguais: false,
      isSuplentesIguais: false,
      modalIsOpen: false,
    };
  }

  agendar = async () => {
    const store = this.props[PROFESSOR_STORE];
    const { suplentes, membros, dia, hora, setValidationError } = store;
    let data = dia + ' ' + hora;
    const { history } = this.props;
    this.setState({ isConvidadosIguais: false, isSuplentesIguais: false })

    const error = AgendamentoValidator.getErrors({ data: data, banca: membros, suplentes: suplentes });
    if (error) {
      setValidationError(error);
      this.scrollToFirstComponentWithError();
      return;
    }

    var isConvidadosIguais = this.verificarSeConvidadosIguais(suplentes, membros);
    if (isConvidadosIguais) {
      return;
    }

    setValidationError({});
    await store.agendarBanca(Number(this.props.match.params.id));
    if (store.agendamentoRealizado) {
      history.push('/professor');
    }
  };

  editarAgendamento = async () => {
    const store = this.props[PROFESSOR_STORE];
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const { dia, hora, setValidationError } = store;
    let dataHora = dia + ' ' + hora;
    let monografiaId = Number(this.props.match.params.id);

    const error = DataHoraValidator.getErrors({ dataHora: dataHora });
    if (error) {
      setValidationError(error);
      this.scrollToFirstComponentWithError();
      return
    }

    setValidationError({});
    this.setState({ modalIsOpen: false });

    await store.editarDataAgendamento(monografiaId);
    if (store.agendamentoRealizado) {
      monografiaStore.getMonografiaComDepositoDoOrientando(monografiaId);
    }
  }

  onResumeClick = () => {
    window.open(Tutorial_Professor);
  }

  verificarSeConvidadosIguais = (suplentes: ProfessorModel[], membros: ProfessorModel[]) => {
    let totalProfessoresConvidados = suplentes.length + membros.length;
    var professoresSet = new Set();
    var suplentesSet = new Set();

    suplentes.forEach(s => suplentesSet.add(s));

    suplentes.forEach(s => professoresSet.add(s));
    membros.forEach(m => professoresSet.add(m));

    if (suplentes.length != suplentesSet.size && professoresSet.size != 1) {
      this.setState({
        isSuplentesIguais: true
      });
      return true;
    }
    if (totalProfessoresConvidados != professoresSet.size) {
      this.setState({
        isConvidadosIguais: true,
        isSuplentesIguais: true
      });
      return true;
    }
    return false;
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const store = this.props[PROFESSOR_STORE];
    const { name, value } = e.target;
    store.updateAttribute(name, value);
  };

  handleProfessorSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    cardIndex: number
  ) => {
    const id = Number(event.target.value);
    const professorStore = this.props[PROFESSOR_STORE];
    const { professores } = professorStore;

    if (id == 0)
      professorStore.updateArray('membros', cardIndex, new ProfessorModel());
    else {
      professorStore.updateArray(
        'membros',
        cardIndex,
        professores.find(p => p.id == id)
      );
    }
  };

  handleSuplenteSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    cardIndex: number
  ) => {
    const id = Number(event.target.value);
    const professorStore = this.props[PROFESSOR_STORE];
    const { professores } = professorStore;

    if (id == 0)
      professorStore.updateArray('suplentes', cardIndex, new ProfessorModel());
    else {
      professorStore.updateArray(
        'suplentes',
        cardIndex,
        professores.find(p => p.id == id)
      );
    }
  }

  componentDidMount = async () => {
    const professorStore = this.props[PROFESSOR_STORE];
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const { id } = this.props.match.params;

    await professorStore.getProfessores();
    monografiaStore.getMonografiaComDepositoDoOrientando(id);
  };

  mapFirstError(element: Object | string): string | undefined {
    const typeOfElement = typeof element;
    if (typeOfElement === 'object') {
      for (const attributeName in element as object) {
        const typeOfChild = typeof element[attributeName];
        if (typeOfChild === 'object') {
          const value = this.mapFirstError(element[attributeName]);
          if (value) {
            return attributeName + '-' + value;
          }
        } else if (typeOfChild === 'string') {
          return attributeName;
        }
      }
    }
    return undefined;
  }

  scrollToFirstComponentWithError() {
    const professorStore = this.props[PROFESSOR_STORE];
    const { professorValidationError } = professorStore;
    if (professorValidationError) {
      const firstErro = this.mapFirstError(professorValidationError);
      if (firstErro) {
        for (const key in this.cardRefs) {
          if (firstErro.includes(key) && this.cardRefs[key].current) {
            this.cardRefs[key].current.scrollIntoView();
            break;
          }
        }
      }
    }
  }

  render() {
    const professorStore = this.props[PROFESSOR_STORE];
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const {
      dia,
      hora,
      professores,
      membros,
      suplentes,
      addSuplente,
      removerSuplente,
      agendamentoRealizado,
      professorValidationError,
      professoresState
    } = professorStore;

    const { monografiaState } = monografiaStore;
    const monografia = monografiaStore.monografia as MonografiaModel;

    const pageState = monografiaState !== apiState.done ? monografiaState :
      professoresState === apiState.done || professoresState === apiState.noContent ? apiState.done : professoresState;

    const diaValue =
      monografia.dataDeApresentacaoSugerida
        ? format(new Date(monografia.dataDeApresentacaoSugerida), 'YYYY-MM-DD')
        : dia;

    const horaValue =
      monografia.dataDeApresentacaoSugerida
        ? format(new Date(monografia.dataDeApresentacaoSugerida), 'HH:mm')
        : hora;

    const membrosList: Array<ProfessorModel> =
      monografia.dataDeApresentacaoSugerida
        ? (monografia as MonografiaModel).banca.filter(b => b.conviteAceito).map(b => b.membro)
        : membros;

    const suplentesList: Array<ProfessorModel> = !monografia.dataDeApresentacaoSugerida ? suplentes : [];

    const { history } = this.props;

    return (
      <>
        <PageSubTitle subTitle={'Agendamento de Banca'} />
        <TutorialButtonAndBackButton
          openTutorial={this.onResumeClick}
          voltar={() => history.push('/professor')}
        />
        <ContainerWithState
          state={pageState}
          notFound='TCC não encontrado'
        >
          {(agendamentoRealizado || (monografia.dataDeApresentacaoSugerida != null) &&
            <Toast type={ToastType.success}>
              <StyledText>Agendamento solicitado </StyledText>
            </Toast>)}
          <GlobalErrorToast messages={professorValidationError && professorValidationError.global} />
          <DetalhesMonografia monografia={monografia} />
          <AgendamentoCard
            dia={diaValue}
            hora={horaValue}
            abrirModal={() => this.setState({ modalIsOpen: true })}
            handleChange={this.handleChange}
            validation={professorValidationError}
            disabled={monografia.dataDeApresentacaoSugerida != null}
            ref={(ref) => { if (ref && ref.cardRef) this.cardRefs = { ...this.cardRefs, ['data']: ref.cardRef }; }}
          />
          {this.state.isConvidadosIguais &&
            <Toast type={ToastType.error}>
              <StyledText>O Membro da Banca convidado deve ser diferente dos suplentes.</StyledText>
            </Toast>}
          {membrosList.map((m, idx) => (
            <ProfessorCard
              key={idx}
              professores={professores}
              handleProfessorSelectChange={e => this.handleProfessorSelectChange(e, idx)}
              membro={m}
              validation={professorValidationError && professorValidationError.banca && professorValidationError.banca[idx]}
              disabled={monografia.dataDeApresentacaoSugerida != null}
              ref={(ref) => { if (ref && ref.cardRef) this.cardRefs = { ...this.cardRefs, [`banca-${idx}`]: ref.cardRef }; }}
            />
          ))}
          {this.state.isSuplentesIguais &&
            <Toast type={ToastType.error}>
              <StyledText>Os Suplentes devem ser diferentes entre si e diferente do Membro da Banca.</StyledText>
            </Toast>}
          <SuplentesCard
            professores={professores}
            suplentes={suplentesList}
            addSuplente={addSuplente}
            removerSuplente={removerSuplente}
            handleSuplenteSelectChange={this.handleSuplenteSelectChange}
            validation={professorValidationError && professorValidationError.suplentes}
            disabled={monografia.dataDeApresentacaoSugerida != null}
            ref={(ref) => { if (ref && ref.cardRef) this.cardRefs = { ...this.cardRefs, ['suplentes']: ref.cardRef }; }}
          />

          <StyledButton
            disabled={agendamentoRealizado || monografia.dataDeApresentacaoSugerida != null}
            onClick={this.agendar}
            color='secondaryColor'
          >
            Solicitar Agendamento
          </StyledButton>

          <EditarAgendamentoModal
            isOpen={this.state.modalIsOpen}
            outterClick={() => this.setState({ modalIsOpen: false })}
            editarAgendamento={this.editarAgendamento}
            conviteAceito={monografia.banca.filter(mb => mb.conviteAceito).length > 0}
            dia={dia}
            hora={hora}
            handleChange={this.handleChange}
            validation={professorValidationError}
          />
        </ContainerWithState>
      </>
    );
  }
}
